<template>
  <div class="header-container">
    <div class="header-wrap">
      <div class="logo">
        <img :src="logoUrl"/>
      </div>
      <div class="content">
        <!--<div class="content-item" v-if="VISIBLE.LOGIN_BTN">
          <el-button type="text" @click="routeTo('/login')">已有账户，去登录 ></el-button>
        </div>-->
        <span :class="['lang',lang==='zh-cn'?'lang-act':'']" @click="switchLanguage">CN</span>
        <span :class="['lang',lang==='en'?'lang-act':'']" @click="switchLanguage">EN</span>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed } from 'vue'
import { useI18n } from "@/plugins/i18n"
import { routesWhiteList } from "@/config/setting.config"
import { useRoute } from 'vue-router'
import { routeTo } from '@/utils'
export default {
  setup() {
    const route = useRoute()
    const { locale, switchLang, lang } = useI18n()
    const state = reactive({
      logoUrl: 'https://oss-img.sunrate.com/common/img/logo/logo-en.png',
      lang: locale
    })

    const methodsGroup = {
      // 切换语言
      switchLanguage() {
        switchLang(locale === lang['zh-cn'] ? lang.en : lang['zh-cn'], { reload: true })
      },
      routeTo
    }

    const scopedComputed = {
      VISIBLE: computed(() => {
        const nonBizFlag = routesWhiteList.includes(route.path)
        return {
          /* LOGIN_BTN: (() => {
            return nonBizFlag && route.path !== routesWhiteList[0]
          })(), */
          PERSONAL_CENTER_BTN: (() => {
            return !nonBizFlag
          })()
        }
      })
    }

    return {
      ...toRefs(state),
      ...methodsGroup,
      ...scopedComputed
    }
  }
}
</script>

<style lang="scss" scoped>
  .header-container {
    width: 100%;
    box-sizing: border-box;
    height: 53px;
    display: flex;
    align-items: center;
    background-color: #E6EAEC;

    .header-wrap {
      width: 100%;
      margin: 0 auto;
      padding: 0 30px;
      display: flex;
      justify-content: space-between;

      .logo {
        width: 100px;
        display: flex;
        align-items: center;

        img {
          width: 100%;
          height: auto;
          display: block;
        }
      }

      .content {
        display: flex;
        align-items: center;
      }

      .content > span:not(:first-child) {
        margin-left: 10px;
      }

      .lang {
        color: #333;
      }

      .lang-act {
        color: #07AEEA;
      }
    }
  }
</style>
